export default {
  NOM:"Nom",
  BUDGET_CONSOMME:"Budget consommé",
  BUDGET_MAX:"Budget max",
  STATUS:"Status",
  ACTION:"Action",
  SEARCH_PLACEHOLDER: "Recherche par nom...",
  ACTIVE: "Actif",
  INACTIVE: "Inactif",
  CREATED_SUCCESS:"Projet créé avec succès",
  USED_PERCENTAGE:"Pourcentage utilisé",
  STATUS_UPDATED_SUCCESS: "Status du projet mis à jour avec succès",
  STATUS_UPDATE_ERROR: "Erreur lors de la mise à jour du statut du projet",
  NAME_UPDATED_SUCCESS: "Nom du projet mis à jour avec succès",
  NAME_UPDATE_ERROR: "Erreur lors de la mise à jour du nom du projet",
  CREATE_ERROR: "Erreur lors de la création du projet",
}